import * as types from './actionTypes';

const initialState = {
  merchantList: null,
  merchantDetails: null,
};

export const merchantListReducer = (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.SET_MERCHANT_LIST:
      return {
        ...state,
        merchantList: action.payload,
      };
    case types.SET_MERCHANT_DETAILS:
      return {
        ...state,
        merchantDetails: action.payload,
      };
    case types.CLEAR_MERCHANT_VIEW:
      return {
        ...state,
        merchantDetails: null,
      };
    default:
      return state;
  }
};
